import React from "react";
import PropTypes from "prop-types";

function PublicLayoutTemplate({ renderChildRoute, ...props }) {
    return <div className="l__public">{renderChildRoute(props)}</div>;
}

PublicLayoutTemplate.propTypes = {
    renderChildRoute: PropTypes.func,
};

export default PublicLayoutTemplate;
